
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as NextIconComponent } from "./next-icon.svg";

export const NextIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <NextIconComponent {...props} />;
};
